import logo from "../photos/logo.jpeg"
import facebook from "../photos/facebook.png"

const AboutPage = ({ language }) => {
    return (
        <>
            <div className="about-content">
                <img
                    className="logo"
                    src={logo}
                />

                <div className="about-content-text-wrapper">
                    {language === "en" &&
                        <div>
                            <div className="biography-text">Lampros Tatsakis's journey in painting began as a deep internal need for expression, evolving into a voyage of discovery. Each of his works is an invitation to connect – a snapshot of the endless dialogue between light and shadow. Beyond technical exploration, his driving force is the idea of the unconscious and its visual embodiment, with the ultimate aim of achieving harmony between the conscious and the expression of emotional depth and quality.</div>
                            <br />
                            <div className="biography-text">His paintings reflect the contemplation provoked by the presence of every living being, as well as the quest for the essence of human experience and the nature of things.</div>
                            <br />
                            <div className="biography-text">He was born in Radovyzi, Ioannina in 1955 and moved to Athens in 1961. He studied at the Medical School of Athens, specialized in Neurology-Psychiatry, and, in the workshop–studio of Maria Kazazi (1988–1993), he studied freehand drawing, printmaking, the theory of light and color, as well as composition. He has been influenced by the movements of Impressionism and Expressionism, has participated in group and solo exhibitions, and his works belong to private collections.</div>
                        </div>
                    }
                    {language === "gr" &&
                        <div>
                            <div className="biography-text">Η διαδρομή του Λάμπρου Τατσάκη στη ζωγραφική ξεκίνησε ως μια βαθιά εσωτερική ανάγκη έκφρασης, εξελισσόμενη σε ένα ταξίδι ανακάλυψης. Κάθε του έργο αποτελεί πρόσκληση για σύνδεση – ένα στιγμιότυπο της ατέρμονης συνομιλίας μεταξύ φωτός και σκιών. Πέραν της τεχνικής αναζήτησης, το κίνητρό του είναι η ιδέα του ασυνείδητου και η οπτική ενσάρκωση, με απώτερο στόχο την επίτευξη αρμονίας μεταξύ του συνειδητού και της έκφρασης του βάθους και της ποιότητας των συναισθημάτων.</div>
                            <br />
                            <div className="biography-text">Οι πίνακές του αντανακλούν το στοχασμό που προκαλεί η παρουσία κάθε ζωντανού πλάσματος, καθώς και η αναζήτηση της ουσίας της ανθρώπινης εμπειρίας και της φύσης των πραγμάτων.</div>
                            <br />
                            <div className="biography-text">Γεννήθηκε στο Ραδοβύζιον Ιωαννίνων το 1955 και μετακόμισε στην Αθήνα το 1961. Σπούδασε στην Ιατρική Σχολή Αθηνών, ειδικεύτηκε στη Νευρολογία-Ψυχιατρική και, στο εργαστήρι – ατελιέ της Μαρίας Καζάζη (1988–1993), μελέτησε ελεύθερο σχέδιο, χαρακτικά, θεωρία του φωτός και του χρώματος, καθώς και συνθέσεις. Έχει δεχθεί επιρροές από τις τάσεις του ιμπρεσιονισμού και του εξπρεσιονισμού, έχει συμμετάσχει σε ομαδικές και ατομικές εκθέσεις, και τα έργα του ανήκουν σε ιδιωτικές συλλογές.</div>
                        </div>
                    }
                </div>
                <div className="about-content-contact">
                    <h2>Contact Details</h2>
                    <div className="about-content-contact-details">
                        <p>E-mail: <a className="contact-email" href="mailto:ltatsakis@yahoo.gr">ltatsakis@yahoo.gr</a></p>
                        <a href="https://www.facebook.com/profile.php?id=100063629978112">
                            <img className="facebook-logo"
                                src={facebook}
                            />
                        </a>

                    </div>
                </div>
            </div >
        </>
    )
}

export default AboutPage;